import { useContext } from 'react';
import LeadModalContext from 'components/domain/lead/modal/LeadModalContext';
import {
  CustomDataFieldType,
  CustomDataFieldUsage,
} from 'models/CustomDataField';
import { useTranslation } from 'react-i18next';

const ExtraInformation = () => {
  const { t } = useTranslation();
  const { lead } = useContext(LeadModalContext);

  if (!lead) {
    return null;
  }

  return (
    <div data-testid="extra-information">
      <h3>
        {t('componentLead.modal.stayDetailsTab.guestInfo.extraInformation')}
      </h3>

      <p data-testid="will-have-visit">
        {t('componentLead.modal.stayDetailsTab.guestInfo.willHaveVisit')}{' '}
        <strong>{lead.willHaveVisit ? t('common.yes') : t('common.no')}</strong>
      </p>

      <p data-testid="will-have-party">
        {t('componentLead.modal.stayDetailsTab.guestInfo.willHaveParty')}{' '}
        <strong>{lead.willHaveParty ? t('common.yes') : t('common.no')}</strong>
      </p>

      {lead.customData
        ?.filter((cd) => cd.usage === CustomDataFieldUsage.PRE_ARRIVAL_FORM)
        .map((cd) => {
          return (
            <p key={cd.uid} data-testid={`custom-data-${cd.name}`}>
              {cd.name}:{' '}
              <strong>
                {cd.type === CustomDataFieldType.LONG_TEXT
                  ? cd.value.longText
                  : cd.value.text}
              </strong>
            </p>
          );
        })}
    </div>
  );
};

export default ExtraInformation;
